export const DEFAULT_PLAYER_NAME_SIZE = 100;

// Stored as a percentage of each theme's original typography, not fixed pixels.
export function normalizePlayerNameSize(value) {
    const size = typeof value === 'number' || typeof value === 'string' ? Number(value) : NaN;
    return Number.isInteger(size) && size >= 100 && size <= 150 ? size : DEFAULT_PLAYER_NAME_SIZE;
}
